<question-description
  titleDir="left"
  subTitleDir="left"
  title="Choisissez votre mandat de gestion"
  subTitle="Faites le choix d’un pack qui correspond à votre profil d’investisseur."
></question-description>

<pr-swiper
  swiperMinWidth="992"
  [config]="config"
  [index]="selectedPack?.index - 1"
  #swiper
>
  @for (pack of packsSwiper; track pack; let i = $index) {
    <pr-slide>
      <div
        class="pack-container"
        (click)="selectPack(pack)"
        [ngClass]="{ active: selectedPack && pack.id === selectedPack.id }"
      >
        <div class="pack-header" [style.background]="utils.getAppColor(i)">
          {{ pack.value }}
        </div>
        <div class="pack-body">
          <ng-container>
            <p class="text-secondary mbl">{{ pack.description }}</p>
            <ng-container [ngTemplateOutlet]="lifeInsurranceTypeTemplate">
            </ng-container>
          </ng-container>
        </div>
        <ng-template #lifeInsurranceTypeTemplate>
          <div class="d-flex justify-content-space-between pvxs">
            <span class="fs-14">Performance</span>
            <span class="text-success">{{
              pack.performance | percent: '.0-2'
            }}</span>
          </div>
          <div class="d-flex justify-content-space-between pvxs">
            <span class="fs-14">Niveau de risque </span>
            <span>{{ pack.risk }}</span>
          </div>
          <div class="d-flex justify-content-space-between pvxs">
            <span class="fs-14">Nombre de supports</span>
            <span>{{ pack.nbSupports }}</span>
          </div>
        </ng-template>
      </div>
    </pr-slide>
  }
</pr-swiper>
<form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
